import { useRef } from 'react';

const SWIPE_THRESHOLD = 50;

// Touch-swipe navigation for carousels — swipe left to advance, swipe right
// to go back, matching the direction convention of a horizontal slider.
function useSwipe(onSwipeLeft, onSwipeRight) {
  const startX = useRef(null);

  const onTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    if (startX.current == null) return;
    const deltaX = e.changedTouches[0].clientX - startX.current;
    if (deltaX <= -SWIPE_THRESHOLD) onSwipeLeft();
    else if (deltaX >= SWIPE_THRESHOLD) onSwipeRight();
    startX.current = null;
  };

  return { onTouchStart, onTouchEnd };
}

export default useSwipe;
